import { FormOutlined } from "@ant-design/icons";
import { Space, Form } from "antd";
import { CheckboxValueType } from "antd/lib/checkbox/Group";
import { ColumnsType } from "antd/lib/table";
import { AddUserModal, EditUsersModal, MenuPage } from "components";
import React, { useState } from "react";
import { api } from "services/api";
import "./style.scss";

export const ManageUsers: React.FC = () => {
	const [refreshTable, setRefreshTable] = useState<boolean>(false);
	const [currentImgURL, setCurrentImgURL] = useState<string>("");
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const [isOpenEdit, setIsOpenEdit] = useState<boolean>(false);
	const [userStatus, setUserStatus] = useState<boolean>(false);
	const [userRoles, setUserRoles] = useState<CheckboxValueType[]>([]);
	const [birthdate, setBirthDate] = useState<string>("");
	const [currentUserInfo, setCurrentUserInfo] = useState<any[]>([]);
	const [form] = Form.useForm();
	const [editForm] = Form.useForm();

	const getUpdatedInfo = async (id: string) => {
		const {
			data: {
				data: { user },
			},
		} = await api.get(`/manager/users/${id}`);
		setCurrentUserInfo(user);
	};

	const columns: ColumnsType<any> = [
		{
			title: "Nome",
			dataIndex: "name",
			key: "name",
			render: (text, record) => (
				<p style={{ margin: 0 }}>{record?.person?.name}</p>
			),
		},
		{
			title: "E-mail",
			dataIndex: "email",
			key: "email",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: () => {
				return {
					width: "20%",
				};
			},
		},
		{
			title: "Data de nascimento",
			dataIndex: "birth_date",
			key: "birth_date",
			render: (text, record) => (
				<p style={{ margin: 0 }}>{record?.person?.birth_date}</p>
			),
			onCell: () => {
				return {
					width: "15%",
				};
			},
		},
		{
			title: "Grupo",
			dataIndex: "group",
			key: "group",
			render: (t_, record) => (
				<p style={{ margin: 0 }}>
					{record?.roles?.map((item: any) => item?.name).join(", ")}
				</p>
			),
		},

		{
			title: "",
			key: "",
			render: (_, record) => (
				<Space size="middle">
					<FormOutlined
						className="edit"
						onClick={async () => {
							await getUpdatedInfo(`${record?.id}`);
							setIsOpenEdit(true);
						}}
					/>
				</Space>
			),
		},
	];

	const handleClickAdd = () => { setIsOpen(true)}
	const handleRefresh = () => {
		setRefreshTable(true);
		setTimeout(() => {
		  	setRefreshTable(false);
		}, 1000);
	};
	const getTableDataFromResponse = (responseData: any) => {
		return responseData.data.users;
	}

	return (
		<div className="users">
			<AddUserModal
				form={form}
				isOpen={isOpen}
				setIsOpen={setIsOpen}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				userStatus={userStatus}
				setUserStatus={setUserStatus}
				userRoles={userRoles}
				setUserRoles={setUserRoles}
				setBirthDate={setBirthDate}
				birthdate={birthdate}
				onCreated={handleRefresh}
			/>
			<EditUsersModal
				form={editForm}
				isOpen={isOpenEdit}
				setIsOpen={setIsOpenEdit}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				userStatus={userStatus}
				setUserStatus={setUserStatus}
				userRoles={userRoles}
				setUserRoles={setUserRoles}
				setBirthDate={setBirthDate}
				birthdate={birthdate}
				onUpdated={handleRefresh}
				currentUserInfo={currentUserInfo}
			/>

			<MenuPage 
				title="Usuários" 
				tableColumns={columns} 
				sourceDataUrl={'/manager/users'}  
				getDataFromResponse={getTableDataFromResponse} 
				addButtonText="+ Adicionar Usuário"
				onClickAdd={handleClickAdd} 
				refreshData={refreshTable}
				searchPlaceholder="Busque por nome ou email"
			/>
		</div>
	);
};
